import(/* webpackMode: "eager", webpackExports: ["TeacherManagementSubPageView"] */ "/web/src/sections/sub-pages/lms/teacher-management/view/teacher-management-sub-page-view.tsx");
